import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { CommonDropdown } from "../../../CommonComponents/CommonDropdown/CommonDropdown";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import { VisitorsTitle } from "../../../../Constants/Constants";
import ReactApexChart from "react-apexcharts";
import { VisitorChart } from "../../../../Data/General/Widgets/General";

const VisitorsCard = () => {
  return (
    <Col md="6" sm="7">
      <Card className="visitor-card">
        <CardHeader className="pb-0">
          <div className="header-top">
            <H4>{VisitorsTitle}
              <span className="f-14 font-primary f-w-500 ms-2">
                <SvgIcon className="svg-fill me-1" iconId="user-visitor" />(+2.8)
              </span>
            </H4>
            <CommonDropdown dropdownClass="dropdown-toggle" />
          </div>
        </CardHeader>
        <CardBody>
          <div className="visitors-container">
            <div id="visitor-chart">
              <ReactApexChart options={VisitorChart} series={VisitorChart.series} type="bar" height={240} />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default VisitorsCard;
